import { render } from "./CompassRose.vue?vue&type=template&id=4de16014"
import script from "./CompassRose.vue?vue&type=script&lang=js"
export * from "./CompassRose.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sjoshi6/git/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__